// assets
import React from 'react';
import {
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormHelperText,
  Grid,
  Link,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography,
  FormControl,
  CircularProgress,
  Alert,
  TextField,
  Snackbar,
  Box,
  Autocomplete,
  Icon
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import { Breadcrumbs } from '@mui/material';
import { Visibility } from '@mui/icons-material';
// icons
const icons = {
  // ChromeOutlined,
  // QuestionOutlined,
  CorporateFareOutlinedIcon,
  ManageAccountsOutlinedIcon,
  PeopleAltOutlinedIcon,
  BadgeOutlinedIcon
};



// ==============================|| MENU ITEMS ||============================== //

const adminpages = {
  id: 'adminMenu',
  title: 'Admin',
  type: 'group',
  children: [
  
    {
      id: 'siteMgmt',
      navTitle: 'Site Management',
      title: 'Site Management',
      type: 'item',
      url: '/default',
      icon: icons.CorporateFareOutlinedIcon,
      breadcrumbs: true,
      visibility:true,
      level:1,
      actionButton:React.any
    },
    {
      id: 'createSite',
      navTitle: 'Create site',
      title: 'Create site',
      type: 'item',
      url: '/default/createSite',
      icon: icons.CorporateFareOutlinedIcon,
      breadcrumbs: true,
      visibility:false,
      level:2,
      actionButton:React.any
    },
    {
      id: 'detailSite',
      navTitle: 'Site Details',
      type: 'item',
      url: '/default/sitedetails',
      icon: icons.CorporateFareOutlinedIcon,
      breadcrumbs: true,
      visibility:false,
      level:2,
      actionButton:React.any
    },
   
    {
      id: 'propManager',
      navTitle: 'Property Managers',
      title: 'Property Managers',
      type: 'item',
      url: '/propertymanager',
      icon: icons.ManageAccountsOutlinedIcon,
      level:1,
      actionButton:React.any,
      visibility:true,
      //external: true,
      //target: true
    },

    {
      id: 'createPMA',
      navTitle: 'Create PMA',
      title: 'Create PMA',
      type: 'item',
      url: '/propertymanager/createPMA',
      icon: icons.ManageAccountsOutlinedIcon,
      level:2,
      actionButton:React.any,
      visibility:false,
      //external: true,
      //target: true
    },
    {
      id: 'detailPMA',
      navTitle: 'PMA Details',
      title: 'PMA Details',
      type: 'item',
      url: '/propertymanager/detailsPMA',
      icon: icons.ManageAccountsOutlinedIcon,
      level:2,
      actionButton:React.any,
      visibility:false,
      //external: true,
      //target: true
    },
   
    {
      id: 'custAcct',
      navTitle: 'Customer Accounts',
      title: 'Customer Accounts',
      type: 'item',
      url: '/CustomerAccount',
      icon: icons.PeopleAltOutlinedIcon,
      level:1,
      visibility:true,
      actionButton:React.any
      
      //external: true,
      //target: true
    },

    {
      id: 'custCreateAcct',
      navTitle: 'Create',
      title: 'Create Customer Account',
      type: 'item',
      url: '/CustomerAccount/Create',
      icon: icons.PeopleAltOutlinedIcon,
      level:2,
      visibility:false,
      actionButton:React.any
      
      //external: true,
      //target: true
    },
    {
      id: 'custDetailsAcct',
      navTitle: 'Details',
      title: 'Customer Account Details',
      type: 'item',
      url: '/CustomerAccount/details',
      icon: icons.PeopleAltOutlinedIcon,
      level:2,
      visibility:false,
      actionButton:React.any
      
      //external: true,
      //target: true
    },
   
    {
      id: 'adminUsers',
      navTitle: 'Admin Users Management',
      title: 'Admin Users Management',
      type: 'item',
      url: '/AdminUserManager',
      icon: icons.BadgeOutlinedIcon,
      level:1,
      visibility:true,
      actionButton:React.any
      //external: true,
      //target: true
    },

    {
      id: 'adminCreateUsers',
      navTitle: 'Create Admin',
      title: 'Create Admin',
      type: 'item',
      url: '/AdminUserManager/createCAM',
      icon: icons.BadgeOutlinedIcon,
      level:2,
      visibility:false,
      actionButton:React.any
      //external: true,
      //target: true
    },

    {
      id: 'adminEditUsers',
      navTitle: 'Admin Details',
      title: 'Admin Details',
      type: 'item',
      url: '/AdminUserManager/detailsCAM',
      icon: icons.BadgeOutlinedIcon,
      level:2,
      visibility:false,
      actionButton:React.any
      //external: true,
      //target: true
    },
   
  ]
};

export default adminpages;
